import { register } from '../modules/sections.js'
import Section from '../modules/section.js'
import { on } from '../modules/events.js'

class PricesSection extends Section {
  initState() {
    return {
      accordionIndex: -1
    }
  }

  init() {
    this.computed(() => this.accordionIndexChanged(this.state.accordionIndex))
    this.accordionSetup()
  }

  accordionSetup() {
    if (!this.refs.toggleItems?.length) {
      return
    }

    this.refs.toggleItems.forEach((el, i) => {
      on(el, 'pointerup', () => {
        this.state.accordionIndex = (i === this.state.accordionIndex) ? -1 : i
      })
    })
  }

  accordionIndexChanged(value) {
    this.refs.items.forEach((el, i) => {
      el.dataset.active = (i === value) ? 1 : 0
    })
  }
}

register('prices', PricesSection)
